define(function(require) {
	return {
		updateModalTitle: function(titleElement, stepNumber, titles) {
			titleElement.fadeOut(150, () => {
				titleElement.text(titles[stepNumber]).fadeIn(150);
			});
		},
		
		animateStepTransition: function($currentStep, $nextStep, direction, callback) {
			const slideOutDirection = direction === 'left' ? '-100%' : '100%';
			const slideInDirection = direction === 'left' ? '100%' : '-100%';
			
			$currentStep.animate({left: slideOutDirection, opacity: 0}, 300, () => {
				$currentStep.hide().css({left: '0', opacity: 1});
				$nextStep.css({left: slideInDirection, opacity: 0}).show();
				$nextStep.animate({left: '0', opacity: 1}, 300, callback);
			});
		}
	};
});